"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_shortcut_option_1 = require("owa-shortcut-option");
var configurationSubCategory = {
    key: 'configuration',
    titleStringKey: 'optionSubcategory_configuration',
    options: [owa_shortcut_option_1.KeyboardShortcutsOption],
};
exports.default = configurationSubCategory;
//# sourceMappingURL=configurationSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-options-general/lib/config/configurationSubCategory.js
// module id = 4968
// module chunks = 2